import { combineEpics } from 'redux-observable';
import { filter, map, mapTo, switchMap } from 'rxjs';
import { isOfType } from 'typesafe-actions';
import { catchAxiosError, catchUnauthorizedError, createEpic$ } from 'lib/store';
import { notificationError } from 'store/notifications';
import { systemUnauthorized } from 'store/system';
import {
  SystemTransactionAction,
  systemTransactionError,
  systemTransactionListResponse,
} from './actions';

const systemTransactionErrorEpic$ = createEpic$(({ action$ }) =>
  action$.pipe(
    filter(isOfType(SystemTransactionAction.Error)),
    mapTo(
      notificationError({
        caption: 'Error',
        duration: 10000,
        message: 'There was a problem loading system transactions',
      }),
    ),
  ),
);

const systemTransactionRequestEpic$ = createEpic$(({ action$, getSystemTransactionList$ }) =>
  action$.pipe(
    filter(isOfType(SystemTransactionAction.ListRequest)),
    switchMap(action =>
      getSystemTransactionList$(action.payload).pipe(
        map(systemTransactionListResponse),
        catchAxiosError(systemTransactionError),
        catchUnauthorizedError(systemUnauthorized),
      ),
    ),
  ),
);

export default combineEpics(systemTransactionErrorEpic$, systemTransactionRequestEpic$);
